import { Spinner } from './Spinner'

/** Suspense fallback for the lazy-loaded route chunks in App.tsx (CustomerView, CraftsmanView,
 *  AdminConsole) - these are mutually-exclusive areas a visitor is only ever in one of at a time,
 *  so splitting them out of the main bundle needs a loading state for the brief gap while the
 *  chunk downloads (docs/tasks/active/seo/tasks.md #3: JS-Bundle-Größe reduzieren). */
export function PageLoadingFallback() {
  return (
    <div className="page-loading-fallback">
      <Spinner />
    </div>
  )
}
